var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.show
    ? _c(
        "button",
        {
          staticClass: "btn wizard-form-control-publish",
          class: [
            _setup.currentData.status ? "btn-success" : "btn-danger",
            { "btn-sm": _setup.formSmall },
          ],
          attrs: { disabled: !_setup.allowPublish, type: "button" },
          on: { click: _setup.onClick },
        },
        [_c("span", [_vm._v(_vm._s(_setup.statusLabel))])]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }